import { useMemo } from "react";

const labels = {
  English: {
    trashBin: "Trash Bin",
    viewAndRestoreDeletedItems:
      "View and restore deleted items from your system.",
    trashbinEmpty: "Trashbin is Empty",
    jobs: "Jobs",
    applicants: "Applicants",
    referenceRequest: "Reference Request",
    referenceQuestions: "Reference Question",
    deletedJobs: "Deleted Jobs",
    deletedApplicants: "Deleted Applicants",
    deletedReferenceRequests: "Deleted Reference Requests",
    deletedReferenceQuestions: "Deleted Reference Questions",
    jobName: "Job Name",
    department: "Department",
    hiringManager: "Hiring Manager",
    deletedDate: "Deleted Date",
    actions: "Actions",
    name: "Name",
    email: "Email",
    applicant: "Applicant",
    referees: "Referees",
    status: "Status",
    question: "Question",
    numberOfQuestions: "No. of Questions",
    selectAll: "Select All",
    clearSelection: "Clear Selection",
    restore: "Restore",
    delete: "Delete",
    restoreAll: "Restore All",
    deleteAll: "Delete All",
    searchPlaceholder: "Search in",
    noItemsInTrash: "No items in trash bin",
    noMatchingItems: "No matching items found for",
    noMatchingJobs: "No jobs found for",
    noMatchingApplicants: "No applicants found for",
    noMatchingReferenceRequests: "No reference requests found for",
    noMatchingReferenceQuestions: "No reference questions found for",
    trashWarning:
      "Items in the trash will be permanently deleted after 10 days. To avoid this, please restore any items you want to keep before the 10-day period ends.",
    departments: {
      sales: "Sales",
      marketing: "Marketing",
      customerService: "Customer Service",
      hr: "Human Resources (HR)",
      finance: "Finance",
      accounting: "Accounting",
      operations: "Operations",
      it: "IT (Information Technology)",
      legal: "Legal",
      administration: "Administration",
      productDevelopment: "Product Development",
      rAndD: "Research and Development (R&D)",
      logistics: "Logistics, Supply Chain & Procurement",
      businessDev: "Business Development",
      pr: "Public Relations (PR)",
      design: "Design",
      compliance: "Compliance",
      riskManagement: "Risk Management",
    },
  },
  Japanese: {
    trashBin: "ゴミ箱",
    viewAndRestoreDeletedItems: "削除済みアイテムの表示と復元。",
    trashbinEmpty: "ゴミ箱は空です",
    jobs: "求人",
    applicants: "応募者",
    referenceRequest: "リファレンスリクエスト",
    referenceQuestions: "リファレンス質問",
    deletedJobs: "削除済みの求人",
    deletedApplicants: "削除済みの応募者",
    deletedReferenceRequests: "削除済みのリファレンスリクエスト",
    deletedReferenceQuestions: "削除済みのリファレンス質問",
    jobName: "求人名",
    department: "部署",
    hiringManager: "採用担当者",
    deletedDate: "削除日",
    actions: "アクション",
    name: "名前",
    email: "メールアドレス",
    applicant: "応募者",
    referees: "推薦者",
    status: "ステータス",
    question: "質問",
    numberOfQuestions: "質問数",
    selectAll: "すべて選択",
    clearSelection: "選択解除",
    restore: "復元",
    delete: "削除",
    restoreAll: "すべて復元",
    deleteAll: "すべて削除",
    searchPlaceholder: "検索",
    noItemsInTrash: "ゴミ箱にアイテムがありません",
    noMatchingItems: "該当するアイテムが見つかりません",
    noMatchingJobs: "該当する求人が見つかりません",
    noMatchingApplicants: "該当する応募者が見つかりません",
    noMatchingReferenceRequests: "該当するリファレンスリクエストが見つかりません",
    noMatchingReferenceQuestions: "該当するリファレンス質問が見つかりません",
    trashWarning:
      "ゴミ箱内のアイテムは10日後に完全に削除されます。必要なアイテムは10日以内に復元してください。",
    departments: {
      sales: "営業",
      marketing: "マーケティング",
      customerService: "カスタマーサービス",
      hr: "人事",
      finance: "財務",
      accounting: "経理",
      operations: "運営",
      it: "IT",
      legal: "法務",
      administration: "総務",
      productDevelopment: "製品開発",
      rAndD: "研究開発",
      logistics: "物流・調達",
      businessDev: "事業開発",
      pr: "広報",
      design: "デザイン",
      compliance: "コンプライアンス",
      riskManagement: "リスク管理",
    },
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
